import ivclass from '@invideoio/web-shared/Modules/IVClass';
import TextWithStyle from './TextWithStyle';

const SUPPORT_BANNER_DESCRIPTION = {
  texts: [
    {
      text: 'Talk to our support team ',
      colorCls: 'iv-text-white-50',
    },
    {
      text: '24/7',
      colorCls: 'iv-text-grey-0',
    },
  ],
};

const Description = () => {
  const fontCls = ivclass(
    'xl:iv-text-heading-xs xl:iv-m-heading-xs',
    'iv-text-body-3xl iv-m-body-3xl',
    'sm:iv-text-body-xl sm:iv-m-body-xl',
    'iv-font-semibold',
  );
  return (
    <TextWithStyle texts={SUPPORT_BANNER_DESCRIPTION.texts} fontCls={fontCls} />
  );
};

export default Description;
